import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import StudentDashboard from './pages/StudentDashboard';
import AdminDashboard from './pages/AdminDashboard';
import EmployeeDashboard from './pages/EmployeeDashboard';
import TeacherDashboard from './pages/TeacherDashboard';
import ProtectedRoute from './ProtectedRoute';
import VerifyRecord from './pages/VerifyRecord';
import BackButtonModal from './BackButtonModal';
import { clearSession } from './components/PortalUI';

function BackButtonHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const isAuth = sessionStorage.getItem('authenticated') || localStorage.getItem('authenticated');
    if (!isAuth || location.pathname === '/') return undefined;

    window.history.pushState(null, '', window.location.href);
    window.history.pushState(null, '', window.location.href);

    const handler = () => {
      window.history.pushState(null, '', window.location.href);
      setShowModal(true);
    };

    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, [location]);

  return showModal ? (
    <BackButtonModal
      onConfirm={() => {
        setShowModal(false);
        clearSession();
        navigate('/', { replace: true });
      }}
      onCancel={() => {
        setShowModal(false);
        window.history.pushState(null, '', window.location.href);
      }}
    />
  ) : null;
}

function App() {
  return (
    <Router>
      <BackButtonHandler />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/student" element={<ProtectedRoute allowedRole="student"><StudentDashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute allowedRole="admin"><AdminDashboard /></ProtectedRoute>} />
        <Route path="/employee" element={<ProtectedRoute allowedRole="employee"><EmployeeDashboard /></ProtectedRoute>} />
        <Route path="/teacher" element={<ProtectedRoute allowedRole="teacher"><TeacherDashboard /></ProtectedRoute>} />
        <Route path="/verify/:type/:id" element={<VerifyRecord />} />
      </Routes>
    </Router>
  );
}

export default App;
